import { invert } from "lodash";
import flatten from "lodash/flatten";

import {
  BUYER,
  DEPLOYMENT,
  LIVESTOCK_AGENT,
  TRANSPORTER,
  VENDOR,
} from "constants/businesses";

import { AgGridTables } from "./aggrid";

export const Settings = {
  addScansToSaleLotButton: "addScansToSaleLotButton",
  agencyId: "agencyId",
  allSalesLoaded: "allSalesLoaded",
  auctionScreenMode: "auctionScreenMode",
  billingRunId: "billingRunId",
  billingRuns: "billingRunId",
  businessPICSelectorAttrFilters: {
    [VENDOR]: "businessPICSelectorVendor",
    [TRANSPORTER]: "businessPICSelectorTransporter",
    [BUYER]: "businessPICSelectorBuyer",
    [LIVESTOCK_AGENT]: "businessPICSelectorLivestockAgent",
    [DEPLOYMENT]: "businessPICSelectorDeployment",
  },
  buyersOnlyAuctionScreen: "buyersOnlyAuctionScreen",
  consignmentAttachmentTypeSelection: "consignmentAttachmentTypeSelection",
  consignmentGroupBy: "consignmentGroupBy",
  failedRequestModalDismissedUntil: "failedRequestModalDismissedUntil",
  fullScreen: "fullScreen",
  globalSearch: "globalSearch",
  saleSearch: "saleSearch",
  showQuickSellDrafting: "showQuickSellDrafting",
  showDeduplicatedWeighLotScans: "showDeduplicatedWeighLotScans",
  isAutoSelectLotEnabled: "isAutoSelectLotEnabled",
  isFailedRequestsModalShowing: "isFailedRequestsModalShowing",
  lastAddedConsignmentId: "lastAddedConsignmentId",
  markColor: "markColor",
  penningMode: "penningMode",
  penView: "penView",
  preferredScanningMode: "preferredScanningMode",
  scanPenOrdering: "scanPenOrdering",
  round: "round",
  savedScanLotRoundId: "savedScanLotRoundId",
  savedScanLotDeploymentId: "savedScanLotDeploymentId",
  saleLotAttachmentTypeSelection: "saleLotAttachmentTypeSelection",
  saleWatcherDraftingInformationId: "saleWatcherDraftingInformationId",
  saveWeightDefaultAction: "saveWeightDefaultAction",
  showConsignmentStepper: "showConsignmentStepper",
  speciesId: "speciesId",
  stickySale: "stickySale",
  watcherViewMode: "watcherViewMode",
  weighLotScaleName: "weighLotScaleName",
  studWatcher: "studWatcher",
  tableViews: "tableViews",
  saleProgress: "saleProgress",
  penScanningGroupType: "penScanningGroupType",
  resolveAlternatives: {
    filterByLastReviewed: "resolveAlternatives.filterByLastReviewed",
    filterByLastModified: "resolveAlternatives.filterByLastModified",
    filterEmptyValues: "resolveAlternatives.filterEmptyValues",
    filterByRoleInSale: "resolveAlternatives.filterByRoleInSale",
    filterByAlternativeSource: "resolveAlternatives.filterByAlternativeSource",
    filteredFields: "resolveAlternatives.filteredFields",
  },
  mtHostSettings: "mtHostSettings",
  ...invert(AgGridTables),
};

export const allowedSettings = [
  ...Object.keys(Settings),
  ...flatten(
    Object.values(Settings)
      .filter(v => typeof v === "object")
      .map(s => Object.values(s)),
  ),
];
